export enum ThemeName {
  Light = 'light',
  Dark = 'dark',
}
